import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import "bootstrap-icons/font/bootstrap-icons.css";
import { API, Auth } from 'aws-amplify'
import React, { useEffect } from 'react'
import { NavLink } from "react-router-dom";
import Button from 'react-bootstrap/Button';

const SuccessfulSubscription = (props) => {
    
    return (
        <Container>
            <br />
            <h3>Your subscription was successful!</h3>
            <Row>
                <Col className="text-align-end">
                    <NavLink to={'/'}>
                        <Button variant="primary">Go back</Button>
                    </NavLink>
                </Col>
            </Row>
        </Container>
    );
};

export default SuccessfulSubscription;
